<script setup>
// §8.1 EntitlementGate — wraps any nav item or widget the licence doesn't
// include. HIDDEN, not disabled (Home widget spec, Axis B). A gated feature
// the customer hasn't bought should not advertise itself as greyed-out.
defineProps({
  entitled: { type: Boolean, default: false },
})
</script>

<template>
  <slot v-if="entitled" />
</template>
